import Vue from "vue";
import * as types from "./mutation-types";

const actions = {};

const questionActions = {
  async fetchQuestion() {
    try {
      let response = await Vue.axios.get(
        `/mental-wellness/assessment/questions`
      );
      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async storeQuestion(_, payload) {
    try {
      const { Questions } = payload;
      let params = {
        Questionnaire: { Questions }
      };
      let response = await await Vue.axios.post(
        `mental-wellness/assessment/save`,
        params
      );
      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchDailyContent() {
    try {
      let response = await Vue.axios.get(`/mental-wellness/daily-content`);
      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchUserPlan() {
    try {
      let response = await Vue.axios.get(`/mental-wellness/plan`);
      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchUserWorkShops({ commit }) {
    try {
      let response = await Vue.axios.get(
        `/mental-wellness/user-workshops?orderBy=startDateDesc`
      );
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_WORKSHOPS, {
        key: "workshops",
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchArticle({ commit }, { articleId }) {
    try {
      let response = await Vue.axios.get(
        `/mental-wellness/article/${articleId}`
      );
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_ARTICLE, {
        key: "article" + articleId,
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchGuide({ commit }, { guideId }) {
    try {
      const response = await Vue.axios.get(`/mental-wellness/guide/${guideId}`);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_GUIDE, {
        key: "guide" + guideId,
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchStrategy({ commit }, { strategyId }) {
    try {
      const response = await Vue.axios.get(
        `/mental-wellness/strategy/${strategyId}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_STRATEGY, {
        key: "strategy" + strategyId,
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchTopic({ commit }, { topicId }) {
    try {
      const response = await Vue.axios.get(`/mental-wellness/topic/${topicId}`);

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_TOPIC, {
        key: "topic" + topicId,
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchTopics({ commit }, { contentType }) {
    try {
      const response = await Vue.axios.get(
        `/mental-wellness/v2/content-list/${contentType}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }
      commit(types.SET_TOPICS, {
        key: "topics",
        value: response.data
      });
      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchArticles({ commit }, { contentType }) {
    try {
      const response = await Vue.axios.get(
        `/mental-wellness/content-list/${contentType}`
      );

      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_ARTICLES, {
        key: "articles",
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async setAssessmentState({ commit }, { assessmentState }) {
    try {
      commit(types.SET_ASSESSMENT_STATE, {
        key: "assessmentState",
        value: assessmentState
      });
    } catch (e) {
      throw e;
    }
  },

  async fetchAssessmentData({ commit }) {
    try {
      let response = await Vue.axios.get(`/mental-wellness/assessmentStatus`);
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_ASSESSMENT_DATA, {
        key: "assessmentData",
        value: response.data
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async fetchWorkshop({ commit }, { workshopId }) {
    try {
      let response = await Vue.axios.get(
        `/mental-wellness/workshop/${workshopId}`
      );
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      commit(types.SET_WORKSHOP, {
        key: "workshop" + workshopId,
        value: response.data
      });

      const userRegistrationState = response.data.data.IsUserRegistered;

      commit(types.SET_WORKSHOP_REG_STATE, {
        key: "workshopRegState" + workshopId,
        value: userRegistrationState
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  },

  async registerOrUnregisterFromWorkshop({ commit }, payload) {
    try {
      const { workshopId, registrationState, memberEmail } = payload;
      let response = await Vue.axios.post(
        `/mental-wellness/workshops?registrationState=${registrationState}&workshopId=${workshopId}&memberEmail=${memberEmail}`
      );
      if (!response.data.success) {
        throw new Error(response.data.message);
      }

      const userRegisterationState = registrationState === "register";

      commit(types.SET_WORKSHOP_REG_STATE, {
        key: "workshopRegState" + workshopId,
        value: userRegisterationState
      });

      return response.data;
    } catch (e) {
      throw e;
    }
  }
};

Object.assign(actions, questionActions);

export default actions;
